var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileImgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M2.667 14.545c.401.122.944.122 1.866.122h6.934c.922 0 1.464 0 1.866-.122m-10.666 0a1.46 1.46 0 0 1-.242-.096 2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108V4.533c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874c.428-.218.988-.218 2.108-.218h6.934c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.218.428.218.988.218 2.108v6.934c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874 1.46 1.46 0 0 1-.242.096m-10.666 0c0-.54.003-.825.05-1.065a2.667 2.667 0 0 1 2.096-2.095c.258-.052.567-.052 1.187-.052h4c.62 0 .93 0 1.187.052a2.666 2.666 0 0 1 2.095 2.095c.048.24.051.525.051 1.065m-2.666-8.212a2.667 2.667 0 1 1-5.334 0 2.667 2.667 0 0 1 5.334 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImgNew);
export default __webpack_public_path__ + "static/media/profile-img-new.ec498ff02405197036639d23f43a102d.svg";
export { ForwardRef as ReactComponent };